import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { instalacionSelector } from '../../../selectors/sessionSelector';
import ImageGallery from 'react-image-gallery';
import { CircularProgress } from '@material-ui/core';
import useVisualizadorImagenes from './useVisualizadorImagenes';
import ImageModal from '../../UI/Modals/ImageModal';
import './styles.css';

const VisualizadorImagenes = ({ item, instalacion, onImageClick }) => {

  const [modalAbierto, setModalAbierto] = useState(false);
  const [imagenModal, setImagenModal] = useState(null);

  const renderImageItem = (imageItem) => (
    <div>
      {imageItem.cargando === true &&
        <div className="imageLoaderArticulo"><CircularProgress /></div>}

      {imageItem.fallida === true &&
        <div className="imageFallida">Imagen no disponible</div>}

      <img
        alt=""
        src={imageItem.original}
        onLoad={() => onImageLoad(imageItem.index)}
        onError={() => onImageLoadError(imageItem.index)}
        onClick={() => handleImagenClick(imageItem.original)}
        style={{ display: imageItem.cargando || imageItem.fallida ? 'none' : 'block', cursor: 'pointer' }}
      />
    </div>
  );

  const handleImagenClick = (imgSrc) => {
    setImagenModal(imgSrc);
    setModalAbierto(true);
  };

  const closeModal = () => {
    setModalAbierto(false);
    setImagenModal(null);
  };
  
  const {
    listaImagenes,
    onImageLoad,
    onImageLoadError,
    onImageGallerySlide,
  } = useVisualizadorImagenes({ item, renderImageItem });

  // Verificar si todas las imágenes han fallado
  const todasImagenesFallidas = listaImagenes && listaImagenes.every(img => img.fallida);

  return (
    <div className='visualizadorImagenes'>
      {(listaImagenes === undefined || todasImagenesFallidas) &&
        <div className='imageDefault'>
          <div>
            <img alt="" src={instalacion.logoCard}></img>
            <div style={{ color: 'black' }}>Producto sin foto</div>
          </div>
        </div>
      }

      {listaImagenes !== undefined && !todasImagenesFallidas &&
        <ImageGallery
          showBullets={false}
          showFullscreenButton={false}
          showPlayButton={false}
          showThumbnails={false}
          showIndex={false}
          items={listaImagenes}
          onSlide={onImageGallerySlide}
        />
      }

      {modalAbierto && <ImageModal open={modalAbierto} onClose={closeModal} imgSrc={imagenModal} />}
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
};

function mapStateToProps(state) {
  return {
    instalacion: instalacionSelector(state),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(VisualizadorImagenes);
